import { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Link } from '@appsumo/dorado-react';
import useUser from '~/lib/user';
import { START_EMAIL_VERIFICATION_DATE } from '~/constants/global';
import { ACCOUNT_PASSWORD_RESET_TYPE } from '~/constants/user';

export function IncompleteMessage({
  isEmailVerified,
  isMissingPassword,
}: {
  isEmailVerified: boolean;
  isMissingPassword: boolean;
}): ReactElement {
  if (!isEmailVerified && isMissingPassword) {
    return (
      <div>
        Before you can redeem your products, we&apos;ll need to confirm your
        email and set an account password.&nbsp;
        <Link href="/account/profile/" styled>
          Finish account setup
        </Link>
        .
      </div>
    );
  } else if (!isEmailVerified) {
    return (
      <div>
        Before you can redeem your products, we&apos;ll need to confirm your
        email.&nbsp;
        <Link href="/account/profile/" styled>
          Request confirmation link.
        </Link>
      </div>
    );
  }

  return (
    <div>
      Complete your account setup by adding a password.&nbsp;
      <Link href="/account/password/update/" styled>
        Set your password
      </Link>
      .
    </div>
  );
}

export default function AccountIncompleteMessaging(): ReactElement {
  const { user } = useUser();
  const isEmailVerified = !!user?.email_verified;
  // is the users join date past our verification start date
  const pastVerificationDate =
    (user &&
      new Date(user.date_joined) > new Date(START_EMAIL_VERIFICATION_DATE)) ??
    false;
  const isMissingPassword = pastVerificationDate
    ? user?.require_password_reset === ACCOUNT_PASSWORD_RESET_TYPE.NEW_ACCOUNT
    : false;
  const showMessaging = isMissingPassword || !isEmailVerified;
  if (!showMessaging || !user) return <></>;

  return (
    <div className="my-4 rounded bg-lemon md:col-span-12">
      <div className="flex flex-row p-3">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className="mr-2 self-center"
          height={24}
          width={24}
        />
        <div>
          <div>
            <b>Looks like your AppSumo account needs a little attention.</b>
          </div>
          <IncompleteMessage
            isEmailVerified={isEmailVerified}
            isMissingPassword={isMissingPassword}
          />
        </div>
      </div>
    </div>
  );
}
